<template>
  <div v-if="legends.length" class="w-full mt-3 flex flex-wrap">
    <div v-for="(legend, index) in legends" :key="'legend_'+index"
      class="flex flex-row items-center border border-gray-300 rounded-full bg-white px-2 py-1 mr-2 mb-2">

      <b-icon v-if="legend.is_completion"
        icon="check-circle"
        pack="fas"
        size="is-small"
        :style="{ color: legend.color }">
      </b-icon>
      <span v-else
        class="rounded-full"
        :style="{ backgroundColor: legend.color, width: '0.9rem', height: '0.9rem', display: 'inline-block', flexShrink: 0 }">
      </span>

      <span class="mx-2 text-sm">{{ legend.name }}</span>

      <button type="button" class="delete is-small" :title="$t('remove')"
        @click="$emit('epc-delete-legend', index)"></button>

    </div>
  </div>
</template>

<script>

export default {
  name: "leyend-document-list",

  props: {
    legends: {
      type: Array,
      required: true
    },
  },

  data() {
    return {

    };
  },

  methods: {

  }
}
</script>
